import * as React from "react";
import * as styles from "./styles.scss";
import { svgIcon } from "../../entryes/panel/students/components/SVGIcon/styles.scss";

interface IProps {
  type: string;
  modifier?: string;
  width?: string;
  height?: string;
  notimage?: boolean;
  title?: string;
  hover?: "opacity" | "opacityInversed";
  style?: React.CSSProperties
}

export class SvgIcon extends React.Component<IProps> {
  render() {
    const attrs = {
      width: this.props.width,
      height: this.props.height,
      className: `svgicon svgicon-${this.props.type} ${
        this.props.modifier ? this.props.modifier : ""
      } ${
        this.props.hover === "opacity"
          ? styles.opacity
          : this.props.hover === "opacityInversed"
          ? styles.opacityInversed
          : ""
      }`,
      title: this.props.title,
    };

    return (
      <>
        {this.props.notimage ? (
          <i {...attrs} />
        ) : (
          <img style={this.props.style} src="/public/images/pix.gif" alt="" {...attrs} />
        )}
      </>
    );
  }
}
